import { Grid, GridSize } from "@material-ui/core";
import * as React from "react";
import { THEME } from "../../theme/ThemeStore";
import { SectionHeaderSmall } from "./Primitives";

type Props = { value: string; onDelete: () => void; sm?: GridSize };

export const LinkField = ({ value, onDelete, sm }: Props) => (
    <Grid item xs={12} sm={sm ?? 6}>
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: `2px dashed ${THEME.customColors.dataUploadBorderColor}`,
                height: 76
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    margin: 16,
                    gap: 16,
                    flex: 3
                }}
            >
                <img src={THEME.Images.icLink} alt="" />
                <SectionHeaderSmall
                    label={value}
                    style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        width: 0,
                        flexGrow: 1
                    }}
                />
            </div>
            <div style={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "flex-end", padding: 16 }}>
                <img src={THEME.Images.icClose} alt="" style={{ cursor: "pointer" }} onClick={onDelete} />
            </div>
        </div>
    </Grid>
);
